import {forwardRef} from 'react'

import {Tooltip} from '../'
import {RichText} from '../../'

import type {TooltipBaseProps} from '../'
import type {TooltipRefProps} from 'react-tooltip'

export interface TooltipProps extends TooltipBaseProps {
  richText: string
}

export const RichTextTooltip = forwardRef<TooltipRefProps, TooltipProps>((props) => {
  const {richText, ...restProps} = props

  const bodyNode = (
    <RichText
      className={'text-glyph-inversed-primary'}
      content={richText}
      allowedTags={['p', 'strong', 'small', 'span']}
    />
  )

  return (
    <Tooltip
      bodyNode={bodyNode}
      {...restProps}
    />
  )
})
